<div class="cust-height">
  <div class="col-12 md:col-12">
    <p-table
      #dt
      [selectionMode]="'single'"
      [columns]="listColumns"
      [value]="trackLog"
      [rows]="100"
      [paginator]="true"
      responsiveLayout="stack"
      [breakpoint]="'960px'"
      >
      <ng-template pTemplate="caption">
        <span class="header-grid-wrapper">
          <span class="align-right">{{'Log' | translate}} : {{'Tot' | translate}} {{ trackLog.length }} {{'Rec_N' | translate}}</span>
        </span>
        <button pButton type="button" icon="pi pi-file-excel" class="cust-width p-button-primary right btn-excel"
          pTooltip="{{'Export_Xlsx' | translate}}"
          tooltipPosition="left"
          (click)="ClickExportExcel()"
        ></button>
        <button pButton type="button" icon="icons8-trash-can" class="cust-width p-button-danger right margin"
          pTooltip="{{'Log_Del' | translate}}"
          tooltipPosition="left"
          (click)="clickDateDelLog()"
        ></button>
      </ng-template>
      <ng-template let-columns pTemplate="header">
        <tr>
          @for (col of columns; track col; let i = $index) {
            <th
              [pSortableColumn]="col.sort"
                [ngClass]="{
                    'width-col-13': col.type === 'DateTime',
                    'width-col-16': col.field === 'login',
                    'width-col-action': col.field === 'codeaction',
                    'width-col-20': col.field === 'username',                            
                    'width-auto': col.field === 'datainfo'
                }"
              >
              @if (col.sort !== null) {
                <p-sortIcon [field]="col.sort"></p-sortIcon>
              }
              {{ col.header }}
              @if (col.field === 'codeaction' && isAdmin === true) {
                <p-dropdown
                  [(ngModel)]="selectedAction"
                  appendTo="body"
                  [options]="stateList"
                  (onChange)="dt.filter($event.value, col.field, 'equals')"
                ></p-dropdown>
              }
              @if (col.field !== 'codeaction') {
                <input
                  (click)="$event.stopPropagation()"
                  pInputText
                  type="text"
                  (input)="dt.filter($event.target.value, col.field, 'contains')"
                  style="color: darkgrey"
                  />
              }
            </th>
          }
        </tr>
      </ng-template>
      <ng-template let-rowData let-columns="columns" pTemplate="body">
        <tr [pSelectableRow]="rowData">
          @for (col of columns; track col; let i = $index) {
            <td class="width-auto">
                @switch (col.field) {
                  @case ('dateaction') {
                    <div class="align-left">
                      {{ rowData[col.field] | datelength | datecompat | date: 'dd/MM/yyyy HH:mm:ss' }}
                    </div>
                  }
                  @case ('codeaction') {
                  <div class="align">
                    @switch (rowData[col.field]) {
                      @case (1) {
                        <i
                          class="pi pi-cog md-18"
                          pTooltip="{{'Editor' | translate}}"
                          tooltipPosition="top"
                        ></i>                        
                      }
                      @case (2) {
                        <i
                          class="icons8-trash-can md-18"
                          style="color: red"
                          pTooltip="{{'Del_Act' | translate}}"
                          tooltipPosition="top"
                        ></i>                        
                      }
                      @case (3) {
                        <i
                          class="pi pi-user md-18"
                          pTooltip="{{'Delegate' | translate}}"
                          tooltipPosition="top"
                        ></i>                        
                      }
                      @case (4) {
                        <i
                          class="pi pi-lock md-18"
                          pTooltip="{{'Access_Right' | translate}}"
                          tooltipPosition="top"
                        ></i>                        
                      }
                      @case (5) {
                        <i
                          class="pi pi-filter md-18"
                          pTooltip="{{'Query_N' | translate}}"
                          tooltipPosition="top"
                        ></i>                        
                      }
                      @case (6) {
                        <i
                          class="pi pi-desktop md-18"
                          pTooltip="{{'Display_N' | translate}}"
                          tooltipPosition="top"
                        ></i>                        
                      }
                      @case (7) {
                        <i
                          class="pi pi-tags md-18"
                          pTooltip="{{'Tag_N' | translate}}"
                          tooltipPosition="top"
                        ></i>                        
                      }
                      @case (8) {
                        <i
                          class="pi pi-desktop md-18"
                          pTooltip="{{'Tag_Bsk' | translate}}"
                          tooltipPosition="top"
                        ></i>                        
                      }
                      @case (9) {
                        <i
                          class="pi pi-desktop md-18"
                          pTooltip="{{'Req_Bsk' | translate}}"
                          tooltipPosition="top"
                        ></i>                        
                      }
                      @case (10) {
                        <i
                          class="pi pi-clock md-18"
                          pTooltip="{{'Pref_25' | translate}}"
                          tooltipPosition="top"
                        ></i>                        
                      }
                      @case (11) {
                        <i
                          class="pi pi-file-import md-18"
                          pTooltip="{{'Load_max' | translate}}"
                          tooltipPosition="top"
                        ></i>                        
                      }
                      @case (12) {
                        <i
                          class="pi pi-desktop md-18"
                          pTooltip="{{'Usr_Bsk' | translate}}"
                          tooltipPosition="top"
                        ></i>                        
                      }
                      @case (13) {
                        <i
                          class="pi pi-id-card md-18"
                          pTooltip="{{'Cm_menu_N' | translate}}"
                          tooltipPosition="top"
                        ></i>                        
                      }
                      @case (14) {
                        <i
                          class="pi pi-clock md-18"
                          pTooltip="{{'Pref_57' | translate}}"
                          tooltipPosition="top"
                        ></i>                        
                      }
                      @case (15) {
                        <i
                          class="pi pi-user-plus md-18"
                          pTooltip="{{'Superv_N' | translate}}"
                          tooltipPosition="top"
                        ></i>                        
                      }
                      @case (16) {
                        <i
                        class="pi pi-desktop md-18"
                          pTooltip="{{'Res_Bsk' | translate}}"
                          tooltipPosition="top"
                        ></i>                        
                      }
                    }                  
                  </div>
                }
                @default {
                    {{ rowData[col.field] }}
                }
              }
            </td>
          }
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7">{{'Empty' | translate}}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-dialog
  [contentStyle]="{overflow: 'visible', width: '30vw'}"
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  >
  <ng-template pTemplate="header">
    <span class="p-dialog-title">
      {{'Log_Del' | translate}}
    </span>
    <span class="small">
      {{'Date_Betw' | translate}}
    </span>
  </ng-template>
  <div class="col-12 align">
    <p-calendar placeholder="{{'Range_Date' | translate}}" class="max-w-full" [showButtonBar]="true" [inline]="true"  [(ngModel)]="rangeDates" selectionMode="range" [readonlyInput]="true"></p-calendar>
  </div>
  <div class="col-12 md:col-12 align-right">
    <button type="button" pButton class="margin p-button-primary p-button-outlined" (click)="closeDia()" label="{{'Cancel' | translate}}"></button>
    <button type="button" pButton class="margin p-button-danger" (click)="clickDelLog()" label="{{'Delete' | translate}}"></button>
  </div>
</p-dialog>

<!-- <app-item-confirm [key]="'delete'" [severity]="'alert'" (onAccept)="delete($event)"></app-item-confirm> -->
